import { DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Pagination } from 'antd';
import Button from 'app/components/Button';
import Card from 'app/components/Card';
import List from 'app/components/List';
import { TextCell } from 'app/components/Table';
import moment from 'moment';
import React from 'react';
import { StyledTotalLabel } from '../../../Table';

type Props = {
  isLoading: boolean;
  onLoadMore: () => void;
  dataSource: any[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
  };
  onDelete: (documentId: number) => Promise<void>;
  onChange: (pagination: { page: number; pageSize: number }) => Promise<void>;
};
const StyledCardItem = styled(Card)`
  margin-left: 16px;
  margin-right: 8px;
  .ant-card-meta-detail {
    .ant-card-meta-title {
      color: #1890ff;
      a {
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
  .ant-card-meta-description {
    > span {
      font-size: 12px;
      font-weight: 400;
      color: #232b3a;
    }
  }
  .ant-card-body {
    padding-left: 0;
    padding-top: 8px;
    padding-bottom: 0;
  }
  .ant-card-actions {
    border-top: none;
    li {
      width: 38px !important;
      margin-left: 16px;
      &:not(:last-child) {
        margin-left: -8px;
        border-right: none;
      }
    }
  }
  .ant-card-cover {
    height: 130px;
    width: 100%;
    padding: 4px;
    border: 0.5px solid #f0f0f0;
    margin: 0 auto;
    > div {
      text-align: center;
      margin: 0 auto;
      > img {
        object-fit: contain;
        object-position: center;
        height: 120px;
        width: 100%;
      }
    }
  }
`;
const StyledList = styled(List)`
  margin-top: 24px;
  margin-bottom: 24px;
  opacity: 1;
  transition: opacity 0.3s, visibility 0.3s;
`;
const StyledPagination = styled(Pagination)`
  text-align: right;
`;
const GridView: React.FC<Props> = ({
  onLoadMore,
  dataSource,
  isLoading,
  pagination,
  onDelete,
  onChange
}) => {
  return (
    <>
      <StyledList
        loadMoreData={onLoadMore}
        height={'auto'}
        renderItem={(record) => {
          const fileName = record.fileName.split(',')[1];
          const date = moment(record.createdAt);
          return (
            <StyledCardItem
              bordered={false}
              cover={
                <div>
                  <a
                    target={'_blank'}
                    download={fileName}
                    style={{ visibility: 'hidden' }}
                    href={record.downloadUrl}
                    id={record.id}
                    rel="noreferrer"
                  ></a>
                  <img src={record.url}></img>
                </div>
              }
              actions={[
                <Button
                  type="text"
                  key={`${record.id}_download`}
                  onClick={() => {
                    const linkNode: any = document.getElementById(record.id);
                    linkNode && linkNode.click();
                  }}
                >
                  <DownloadOutlined></DownloadOutlined>
                </Button>,
                <Button
                  type="text"
                  danger
                  key={`${record.id}_delete`}
                  onClick={() => {
                    onDelete(record.id);
                  }}
                >
                  <DeleteOutlined></DeleteOutlined>
                </Button>
              ]}
            >
              <Card.Meta
                title={
                  <a href={record.url} target="_blank" rel="noreferrer">
                    {fileName}
                  </a>
                }
                description={
                  <TextCell>
                    {date.isValid() ? date.format('DD/MM/YYYY') : 'N/A'}
                  </TextCell>
                }
              ></Card.Meta>
            </StyledCardItem>
          );
        }}
        dataSource={dataSource}
        listProps={{
          loading: isLoading,
          grid: {
            column: 5
          }
        }}
      ></StyledList>
      <StyledPagination
        onChange={(page, pageSize) => {
          onChange({
            page: page,
            pageSize: pageSize
          });
        }}
        total={pagination.total}
        current={pagination.page}
        pageSize={pagination.pageSize || 10}
        showSizeChanger
        showTotal={(total, range) => {
          return (
            <StyledTotalLabel>
              {range[0]}-{range[1]} of {total}
            </StyledTotalLabel>
          );
        }}
      ></StyledPagination>
    </>
  );
};

export default GridView;
